import { render, staticRenderFns } from "./distributionRealtime1.vue?vue&type=template&id=d987a324&scoped=true&"
import script from "./distributionRealtime1.vue?vue&type=script&lang=js&"
export * from "./distributionRealtime1.vue?vue&type=script&lang=js&"
import style0 from "./distributionRealtime1.vue?vue&type=style&index=0&id=d987a324&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d987a324",
  null
  
)

export default component.exports